"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var styles = __importStar(require("./DatePicker.module.css"));
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.maxLength = 10;
        _this.pdf = document.body.classList.contains("pdf");
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, _b = _a.errors, errors = _b === void 0 ? {} : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, min = _a.min;
        var value = json_data[id] || "";
        var error = errors[id];
        var classRoot = styles.root + " " + (error && styles.rootError);
        if (this.pdf) {
            value = moment_1.default(json_data[id]).format("DD/MM/YYYY");
        }
        return (React.createElement("div", null,
            React.createElement("input", { className: classRoot, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: "date", disabled: disabled, maxLength: this.maxLength, min: min, max: "2999-12-31" }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePicker;
}(React.Component));
exports.DatePicker = DatePicker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZVBpY2tlci5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvRGF0ZVBpY2tlci9EYXRlUGlja2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBRzlCLGtEQUEyQjtBQUMzQiw4REFBaUQ7QUFXakQ7SUFBZ0MsOEJBQW9DO0lBSWhFLG9CQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FHZjtRQVBPLFNBQUcsR0FBRyxLQUFLLENBQUE7UUFDWCxlQUFTLEdBQUcsRUFBRSxDQUFBO1FBS2xCLEtBQUksQ0FBQyxHQUFHLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFBOztJQUN0RCxDQUFDO0lBRU0sMkJBQU0sR0FBYjtRQUNVLElBQUEsZUFBMEUsRUFBekUsd0JBQVMsRUFBRSxVQUFFLEVBQUUsc0JBQVEsRUFBRSxjQUFXLEVBQVgsZ0NBQVcsRUFBRSxnQkFBZ0IsRUFBaEIscUNBQWdCLEVBQUUsWUFBaUIsQ0FBQTtRQUNoRixJQUFJLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQy9CLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUN4QixJQUFNLFNBQVMsR0FBTSxNQUFNLENBQUMsSUFBSSxVQUFJLEtBQUssSUFBSSxNQUFNLENBQUMsU0FBUyxDQUFFLENBQUE7UUFFL0QsSUFBSSxJQUFJLENBQUMsR0FBRyxFQUFFO1lBQ1YsS0FBSyxHQUFHLGdCQUFNLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxDQUFBO1NBQ3JEO1FBRUQsT0FBTyxDQUNIO1lBQ0ksK0JBQ0ksU0FBUyxFQUFFLFNBQVMsRUFDcEIsRUFBRSxFQUFFLEVBQUUsRUFDTixLQUFLLEVBQUUsS0FBSyxFQUNaLFFBQVEsRUFBRSxVQUFDLEtBQUs7b0JBQ1osUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO2dCQUNwQyxDQUFDLEVBQ0QsSUFBSSxFQUFDLE1BQU0sRUFDWCxRQUFRLEVBQUUsUUFBUSxFQUNsQixTQUFTLEVBQUUsSUFBSSxDQUFDLFNBQVMsRUFDekIsR0FBRyxFQUFFLEdBQUcsRUFDUixHQUFHLEVBQUMsWUFBWSxHQUNsQjtZQUNELEtBQUssSUFBSSwyQkFBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLEtBQUs7Z0JBQUcsS0FBSztvQkFBTSxDQUNoRCxDQUNULENBQUE7SUFDTCxDQUFDO0lBQ0wsaUJBQUM7QUFBRCxDQUFDLEFBdkNELENBQWdDLEtBQUssQ0FBQyxTQUFTLEdBdUM5QztBQXZDWSxnQ0FBVSJ9